export enum InsuranceQuoteStatus {
    OPEN = 'open',
    CLOSED = 'closed',
    PROCESSING = 'processing'
}
